
/* --------------- first anime --------------- */
window.addEventListener('DOMContentLoaded', function() {
  setTimeout(function() {
        document.querySelector('.mv__ttl').classList.add('on');
  }, 300);
  
  setTimeout(function() {
        document.querySelector('.mv__nav').classList.add('on');
  }, 900);

  setTimeout(function() {
    const fadeinElements = document.querySelectorAll('.fadein_se');
    fadeinElements.forEach(function(element, index) {
      setTimeout(function() {
        element.classList.add('in');
      }, index * 200);
    });
  }, 1000);
});

/* --------------- scroll anime --------------- */
window.addEventListener('load', function() {
  window.addEventListener('scroll', function() {
    const toggleclass = document.querySelectorAll('.scroll_anime');
    const wh = window.innerHeight;
    const ws = window.scrollY;

    toggleclass.forEach(function(element) {
      const elemOffset = element.getBoundingClientRect().top + window.scrollY;
      if (ws > (elemOffset - wh) + 20) {
        element.classList.add('scroll__start');
      }
    });
  });
});

window.addEventListener('scroll', function() {
  const scrollElements = document.querySelectorAll('.scroll_anime');
  const scroll = window.scrollY;
  const windowHeight = window.innerHeight;

  scrollElements.forEach(function(element) {
    const elemPos = element.getBoundingClientRect().top + scroll;
    if (scroll > elemPos - windowHeight + 50) {
      element.classList.add('scrollin');
    }
  });
});
